import type { FilterOptionType } from '@providers/FilterProvider';
import type { MaybeArrayItem } from '@types';
import { formatRatingValue, toItemArray } from '@utils';

import type { FilterOptionProps } from '../FilterOption';
import FilterOption from '../FilterOption';
import { filterOptionItemSettings } from '../FilterOptionItem';
import type { FilterOptionRatingItemProps as ItemProps } from './Item';
import FilterOptionRatingItem from './Item';

export type FilterOptionRatingProps<FilterOption extends FilterOptionType> = {
  option: FilterOption;
  filterOptionProps?: Partial<FilterOptionProps>;
  starColor: string;
  showExactRating?: boolean;
  filterOptionItemProps: (
    optionItem: MaybeArrayItem<FilterOption['values']>
  ) => Pick<ItemProps, 'value' | 'from' | 'to' | 'docCount'>;
};

const FilterOptionRating = <FilterOption extends FilterOptionType>({
  option,
  filterOptionProps,
  starColor,
  filterOptionItemProps,
  showExactRating,
}: FilterOptionRatingProps<FilterOption>) => {
  const itemSettings = filterOptionItemSettings(option);

  return (
    <FilterOption option={option} {...filterOptionProps}>
      {({ filterOptions }) => {
        return toItemArray(filterOptions).map((optionItem) => {
          const itemProps = filterOptionItemProps(optionItem);

          return (
            <FilterOptionRatingItem
              key={itemProps.value}
              starColor={starColor}
              filterOptionId={option.filterOptionId}
              settings={itemSettings}
              adaLabel={formatRatingValue(itemProps.from, true, itemProps.docCount)}
              showExactRating={showExactRating}
              {...itemProps}
              {...filterOptionProps}
            />
          );
        });
      }}
    </FilterOption>
  );
};

export default FilterOptionRating;
